const Form015TC = {
    stepName: {
        ImportantNotes: "重要提示",
        PersonalInfo: "教師資料",
        Nominate: "Nominated Rewards",
        Confirmation: "確認",
        ServiceRecord: "Service Record",
    },
    importantNotes: {
        p_title: "個人資料收集聲明",
        p1_1: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
        p1_a: "辦理與聘用有關的事宜；",
        p1_b: "處理發放薪金津貼，以及計算公積金的供款和贈款；",
        p1_c: "進行核數工作；",
        p1_d: "進行研究及統計資料，以便規劃教育服務；",
        p1_e: "處理有關教育專業人員發展的事宜；",
        p1_f: "執行《教育條例》、《教育規例》及附屬《補助/津貼學校公積金規則》(第279章)。",

        p2: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
        p3: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
        p4: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
        p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
    },
    errorMsg: {
        "E-0106": "AA000000(A)",
        "E-0101": "不允許使用中文數字",
        "E-0102": "請輸入中文",
        college: "學院",
        notPublicUser: "此表格只能由公眾用戶提交",
    },
    titleOption: {
        Mr: "先生",
        Mrs: "女士",
        Miss: "小姐",
    },
    label: {
        ImportantNotesContent: {
            title: "個人資料收集聲明",
            p_title: "收集個人資料的目的",
            p1_1: "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
            p1_a: "處理、核實及查證教師註冊的申請；",
            p1_b: "就上文(a)項所述申請的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
            p1_c: "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；",
            p1_d: "培訓及發展，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
            p1_e: "處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計；",
            p1_f: "編製統計資料、研究及政府刊物；以及",
            p1_g: "執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)、《資助則例》和《專上學院條例》(香港法例第320章) 及其附屬法例]。",

            p2: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理申請。",

            p_title3: "可獲轉移資料者",
            p3_1: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
            p3_a: "政府其他政策局及部門，包括香港警務處，以用於上文第1段所述的用途；",
            p3_b: "與本表格相關的學校，以用於上文第1段所述的用途；",
            p3_c: "你曾就披露個人資料給予訂明同意；以及；",
            p3_d: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",

            p_title4: "查閱個人資料",
            p4: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向教師註冊小組提出(地址：九龍協調道3號工業貿易大樓2樓)。",
            // p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
        },
        rewardOption: {
            Male: "男",
            Female: "女",
        },
        genderOption: {
            M: "男",
            F: "女",
        },
        regardingOption: {
            know: "知悉",
            notKnow: "不知悉",
        },
        fullTimePartTime: {
            fullTime: "全職",
            PartTime: "兼任",
        },
        unitOption: {
            perHour: "每小時",
            perWeek: "每週",
            perMonth: "每月",
        },
        partTimeHours: "兼任時數",

        photographs: "簽名照片",
        certificate: "健康檢查證明書",
        certificates: "學歷證書或其他有關學歷資格的證據",

        educated: "(g) 肄業的院校名稱及日期：",
        termsConditions:
            "本人已閱讀及明白《專上學院條例》（第 320 章）及《專上學院規例》（第 320 章，附屬法例 A）。",
        iamStatement: "我理解申請人需要擁有「智方便+」賬戶才能處理申請。",
        college: "提交申請的學院",
        date: "日期",
        title: "稱謂",
        notes1: "1. 現經校務委員會批准，本人申請將",
        notes2: "註冊為本學院教師，有關該人的詳情列於下文。",
        notes3: "2. 教師的資料：",
        teacherName: "姓名（中文）",
        englishName: "姓名（英文）",
        chineseName: "姓名（中文）",
        aliases: "別名",
        sex: "(d) 性別",
        dateBirth: "(e) 出生日期",
        placeBirth: "出生地點",
        university: "學校或大學",
        fromMonth: "由年／月",
        toMonth: "至年／月",
        educational: "學歷資格（證書、文憑、學位）",
        detailsOccupation: "(i) 離開學校、學院或大學後曾從事教學以外的職業細節",
        teachingExp: "(j) 所有教學經驗細節:",
        school: "學校",
        schoolfromMonth: "由年／月",
        schooltoMonth: "至年／月",
        classestaught: "任教班級",
        subjectstaught: "任教科目",
        publications: "(k) 任何曾發表的作品或原創研究的細節",
        subjectsTaught: "<b>3. 將任教科目</b>",
        subjectsTaughtError: "將任教科目",
        subjectsTaughtCon: "3. 將任教科目",
        proposedSalary: "<b>4. 擬付薪金</b>",
        proposedSalaryCon: "4. 擬付薪金",
        workingTime: "5. 全職或兼任",
        partTime: "（註明時數）",
        otherWorkingTime: "註明時數",
        regarding3:
            "6. 有關該教師的品格，可向以下人士查詢，此等人士<b>{{fieldName}}</b>在此表格上填寫的各項陳述:",
        regarding1: "6. 有關該教師的品格，可向以下人士查詢，此等人士",
        regarding2: "在此表格上填寫的各項陳述: ---",
        identityDocment: "身分證明文件",
        name: "姓名",
        occupation: "職業",
        address: "地址",
        /* qualifications:
            "本人附交該教師的 ——（a）簽名照片3張（b）健康檢業證明書（c）學歷證書或其他有關學歷資格的證據", */
        qualifications: {
            attach: "7. 本人附交該教師的 ——",
            a: "（a）簽名照片3張",
            b: "（b）健康檢查證明書",
            c: "（c）學歷證書或其他有關學歷資格的證據",
        },
        photograph: "照片",
        card: "身分證號碼",
        president: "校長（簽署）",
        approverEmailAddress: "電郵地址",
    },
};
export default Form015TC;
